import React, { useEffect, useState } from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';

import css from './SectionHero.module.css';

const SectionHero = props => {
  const [mounted, setMounted] = useState(false);
  const { rootClassName, className } = props;

  useEffect(() => {
    setMounted(true);
  }, []);

  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <div className={css.heroContent}>
				<div className={css.heroTitlesBackground}>
		        <h1>
		          <span className={classNames(css.heroMainTitle, { [css.heroMainTitleFEDelay]: mounted })}><FormattedMessage id="SectionHero.title" /></span>
              <span className={classNames(css.heroMainTitleTM, { [css.heroMainTitleFEDelay]: mounted })}>™</span>
		        </h1>
		        <h2 className={classNames(css.heroSubTitle, { [css.heroSubTitleFEDelay]: mounted })}>
		          <FormattedMessage id="SectionHero.subTitle" />
		        </h2>
				</div>
        <NamedLink
          name="SearchPage"
          className={classNames(css.heroButton, { [css.heroButtonFEDelay]: mounted })}
        >
          <FormattedMessage id="SectionHero.browseButton" />
        </NamedLink>
      </div>
    </div>
  );
};

SectionHero.defaultProps = { rootClassName: null, className: null };

SectionHero.propTypes = {
  rootClassName: string,
  className: string,
};

export default SectionHero;
